<template>
  <div class="spa-checkout">
    <div
      class="spa-checkout__wrapper"
    >
      <SpaCheckoutForm />
      <SpaCheckoutSidebar />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { SPA_SOFT_ROUTE_NAMES } from '@components/07.spa-soft/spa-soft/routes/spa-soft-routes'
  import SpaCheckoutSidebar from './components/spa-checkout-sidebar.vue'
  import SpaCheckoutForm from './components/spa-checkout-form.vue'

  export default {
    name: 'SpaCheckout',
    components: {
      SpaCheckoutForm,
      SpaCheckoutSidebar
    },
    beforeRouteEnter(to, from, next) {
      next(async (vm) => {
        if (vm.ready) {
          if (!vm.selectedItinerary) {
            vm.goToStep(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE)
            return false
          }
        }
        return true
      })
    },
    computed: {
      ...mapState('spaSoft', ['ready', 'selectedItinerary']),
    },
    watch: {
      async ready(val) {
        if (val) {
          if (!this.selectedItinerary) {
            this.goToStep(SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE)
          }
        }
      },
    },
    created() {
      this.$track({ event: 'pageView' })
    },
    methods: {
      ...mapActions('spaSoft', ['goToStep']),
    },
  }
</script>
